import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";

export class RatingViewModel {
  public content_type: number;
  public content_id: number;
  public hyp_cus_nr: number; // is it needs for ui? this is a liked location of user
  public message: string;
  public rating: number;
}

// Requests
export class RatingSyncModel extends SyncModel {
  public ratings: SetRatingModel[];
}

export class SetRatingModel {
  public content_type: number;
  public content_id: number;
  public message: string;
  public rating: number;
}

// Responses
export class RatingDataModel extends DataModel {
  public get DM_Key(): number | string { return this.content_type + "|" + this.content_id; }
  public content_type: number; // todo need enum
  public content_id: number;
  public app_version: string;
  // home location (or 0)
  public hyp_cus_nr: number;
  public message: string;
  // percent between 1 - 100 (or 0)
  public rating: number;
  public create_at_ymd: number;
  public create_at_hms: number;
  public get create_at(): Moment {
    return Utils.GetMomentFromInt(this.create_at_ymd, this.create_at_hms);
  }
}

export class RatingSyncDataModel extends SyncDataModel {
  public ratings: RatingDataModel[];
  public get models(): DataModel[] { return this.ratings; }
  public DeserializeType(): void {
    this._DeserializeType(RatingDataModel);
  }
}
